import "moment-timezone";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import AuthContext from "../auth-context";
import PhoneNumber from "../Shared/PhoneNumber";

class CallRecordsTable extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = { items: props.items };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({ items: this.props.items });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.items === prevState.items
      ? {}
      : { items: nextProps.items };
  }

  handleSelectChange = (event, id) => {
    const checked = event.target.checked;
    this.changeSelectedState(id, checked);
  };

  changeSelectedState = (id, checked) => {
    this.props.itemSelectStateChanged(id, checked);
  };

  handleSelectAllChange = event => {
    if (this.state.checkedSelectAll) {
      this.props.itemSelectAllChanged(false);
      this.setState({ checkedSelectAll: false });
    } else {
      this.props.itemSelectAllChanged(true);
      this.setState({ checkedSelectAll: true });
    }
  };

  toggleMediaControls = id => {
    const items = this.state.items.map(item => {
      if (item.id === id) {
        item.showControls = !item.showControls;
      }
      return item;
    });
    this.setState({ items: items });
  };

  render() {
    const CallRecordsTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <CallRecordsTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />
          ))}
        </tbody>
      );
    };

    const CallRecordsTableHeader = props => {
      return (
        <thead className="dark">
          <tr>
            {this.props.itemSelectStateChanged && (
              <th style={{ width: 10 }}>
                <input
                  type="checkbox"
                  checked={this.state.checkedSelectAll}
                  onChange={this.handleSelectAllChange}
                />
              </th>
            )}
            <th style={{ width: 10 }}>ID</th>
            <th>At</th>
            <th>From</th>
            <th>To</th>
            <th>Call Status / Recording</th>
            <th>Replit Score</th>
          </tr>
        </thead>
      );
    };

    const RecordingLink = props => {
      const authStore = this.context;
      const isAdmin = authStore.hasRole("admin");
      const { call_record } = props;
      if (!call_record.recording_url) {
        return <div></div>;
      }

      return (
        <div>
          {call_record.voicemail && (
            <div>
              {call_record.showControls && (
                <>
                  {call_record.voicemail_responded ? (
                    <span className="pull-right text-info">Closed</span>
                  ) : (
                    <Button
                      bsStyle="info"
                      className="btn-xs pull-right"
                      onClick={() => props.itemMarkCompleted(call_record.id)}
                    >
                      Mark Closed
                    </Button>
                  )}
                </>
              )}
              <button
                className="button-link"
                onClick={() => this.toggleMediaControls(call_record.id)}
              >
                Listen
              </button>
            </div>
          )}

          {!call_record.voicemail && isAdmin && (
            <button
              className="button-link"
              onClick={() => this.toggleMediaControls(call_record.id)}
            >
              {call_record.recording_call_status} (
              {call_record.recording_duration} seconds)
            </button>
          )}

          {call_record.showControls && (
            <audio controls width="200" height="32">
              <source src={call_record.recording_url} type="audio/mp3" />
            </audio>
          )}
        </div>
      );
    };

    const CallRecordsTableItem = props => {
      const authStore = this.context;
      const isAdmin = authStore.hasRole("admin");
      const call_record = props.item;
      return (
        <tr>
          <td data-label="Select">
            {this.props.itemSelectStateChanged && (
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                checked={call_record.isSelected}
                onChange={event =>
                  this.handleSelectChange(event, call_record.id)
                }
              />
            )}
          </td>
          <td data-label="ID">#{call_record.id}</td>
          <td data-label="At">
            <Moment format="MMM Do YYYY h:mma">{call_record.at}</Moment>
          </td>
          <td data-label="From">
            {call_record.direction === "in" ? (
              <span>
                <PhoneNumber number={call_record.contact_number}></PhoneNumber>{" "}
                {call_record.lm_contact_id && (
                  <span>
                    /{" "}
                    <Link to={`/m1/contacts/${call_record.lm_contact_id}`}>
                      contact
                    </Link>
                  </span>
                )}
              </span>
            ) : (
              <span>{call_record.m1_user_email}</span>
            )}
          </td>
          <td data-label="To">
            {call_record.direction === "in" ? (
              <span>
                {call_record.m1_user_email ||
                  (call_record.m1_number === "+61488851823"
                    ? "Emerson Line 1"
                    : call_record.m1_number === "+61489077741"
                    ? "Emerson Line 2"
                    : call_record.m1_number === "+61483961337"
                    ? "Emerson Line 3"
                    : call_record.m1_number === "+61488855574"
                    ? "Emerson Old"
                    : "")}
              </span>
            ) : (
              <span>
                <PhoneNumber number={call_record.contact_number}></PhoneNumber>{" "}
                {call_record.lm_contact_id && (
                  <span>
                    /{" "}
                    <Link to={`/m1/contacts/${call_record.lm_contact_id}`}>
                      contact
                    </Link>
                  </span>
                )}
              </span>
            )}
          </td>
          <td data-label="Call Status / Recording">
            {call_record.dial_call_duration > 0 ||
            call_record.dial_call_status === "Completed" ? (
              <RecordingLink {...this.props} call_record={call_record} />
            ) : (
              call_record.dial_call_status
            )}
          </td>
<td data-label="Replit Report">
            {isAdmin && (
              call_record.confirmation_call ? (
                <>
                  {call_record.replit_score || call_record.replit_url ? (
                    <>
                      <div>Score: {call_record.replit_score}</div>
                      {call_record.replit_url && (
                        <a
                          href={call_record.replit_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-xs btn-info"
                          style={{ marginTop: 4 }}
                        >
                          View Report
                        </a>
                      )}
                    </>
                  ) : (
                    <div style={{ color: '#999', fontStyle: 'italic' }}>
                      {call_record.recording_duration < 60
                        ? 'Less than 60 secs'
                        : call_record.outcome
                        ? call_record.outcome
                            .split('_')
                            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                            .join(' ')
                        : ''}
                    </div>
                  )}
                </>
              ) : (
                <div style={{ color: '#999', fontStyle: 'italic' }}>
                  Not a TCS call
                </div>
              )
            )}
          </td>
        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <CallRecordsTableHeader />
          <CallRecordsTable items={this.state.items} />
        </table>
      </div>
    );
  }
}

export default CallRecordsTable;
